<template>
  <div class="absolute top-0px ledger-tab">
    <div
      v-for="item of getLedgerTabList"
      :key="item.code"
      class="ledger-tab-item"
      :class="{ active: item.code === activeTab }"
      @click="changeTab(item)"
    >
      {{ item.tabName }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    collapsePanel: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: '',
    },
    onlyDeviceProp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 设备台账二级菜单列表
      ledgerTabList: [],
    }
  },
  methods: {
    changeTab(data) {
      this.$emit('changeTab', data)
    },
  },
  computed: {
    getLedgerTabList() {
      if (this.onlyDeviceProp) {
        return [
          {
            tabName: '设备属性',
            name: '设备属性',
            code: 'DeviceMaintainRecord',
            origin: 'DevicePanel',
            hideTitle: false,
          },
        ]
      }
      return [
        {
          tabName: '基础信息',
          name: '设备基础信息',
          code: 'DeviceRealBasicInfo',
          origin: 'DevicePanel',
          hideTitle: false,
        },
        {
          tabName: '关联监控',
          name: '设备关联监控',
          code: 'DeviceMonitor',
          origin: 'DevicePanel',
          hideTitle: false,
        },
        {
          tabName: '设备诊断',
          name: '设备诊断',
          code: 'DeviceDiagnosticsDetail',
          origin: 'DevicePanel',
          hideTitle: false,
        },
        {
          tabName: '其他信息',
          name: '其他信息',
          code: 'DeviceOtherInfo',
          origin: 'DevicePanel',
          hideTitle: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.ledger-tab {
  display: flex;
  flex-direction: column;
  left: -45px;
  .ledger-tab-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 40px;
    height: 100px;
    padding: 0 10px;
    margin-bottom: 20px;
    text-align: center;
    background-color: #2a4e51;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
  }
  .active {
    color: #9aeaff;
  }
}
</style>
